import React from 'react';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import { useFormulaList, useProductQc } from '../graphql/queries';
import Loading from '../teal-react/components/molecules/Loading';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import Typo from '../teal-react/components/atoms/Typo';
import Utils from '../teal-react/utils';
import MaxBox from '../teal-react/components/atoms/MaxBox';
import K from '../Constants';
import { Add } from '@mui/icons-material';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import { useGraphPurge, useMutation } from '../graphql/hooks';
import { useAuth } from '../teal-react/utils/token';

const QcList = ({
  data,
  status,
  header,
  onSelect,
  formulas,
  product_id,
  createBatch,
}: {
  data: any;
  status: string;
  header: string;
  onSelect: (t: any) => void;
  formulas?: any[];
  product_id?: number;
  createBatch?: any; //(t: any) => Promise<any>;
}) => {
  const { user } = useAuth();
  const clearCache = useGraphPurge();
  const [anchor, setAnchor] = React.useState<any>();
  const list = data.qc.filter((t: any) => t.status === status);
  const fullheader = list.length ? `${header} (${list.length})` : header;
  const HAS_WRITE_ACCESS = !user?.isRO;

  const handleClose = () => {
    setAnchor(null);
  };

  const handleCreateBatch = (formula_id: number, status?: string) => {
    setAnchor(null);
    createBatch?.({
      variables: {
        input: {
          product_id,
          formula_id,
          updated_by: user?.email,
          status,
        },
      },
    })?.then((r: any) => {
      onSelect({ id: r.data.createNewBatch });
      clearCache('qc');
    });
  };

  const action =
    HAS_WRITE_ACCESS &&
    status === K.status.UNTESTED &&
    (formulas?.length ?? 0) > 1 ? (
      <>
        <IconButton
          size="small"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchor(event.currentTarget);
          }}
        >
          <Add color="primary" />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <div style={{ padding: '0 8px' }}>{Typo.header('Formula')}</div>
          <Divider />
          {formulas?.map((f: any) => (
            <MenuItem
              key={'formula' + f.id}
              onClick={() => {
                handleCreateBatch(f.id);
              }}
            >
              {f.name}
            </MenuItem>
          ))}
        </Menu>
      </>
    ) : undefined;
  const headeraction =
    status === K.status.UNTESTED && HAS_WRITE_ACCESS
      ? {
          icon: <Add />,
          onClick: () => {
            handleCreateBatch(formulas?.[0]?.id || 0);
          },
        }
      : status === K.status.QCONLY && HAS_WRITE_ACCESS
      ? {
          icon: <Add />,
          onClick: () => {
            handleCreateBatch(0, K.status.QCONLY);
          },
        }
      : null;

  return (
    <SimpleCard
      noGutter
      subheader={fullheader}
      headeraction={headeraction}
      action={action}
    >
      <MaxBox mb={45}>
        <SimpleTable
          noCard
          noTH
          data={list}
          row_action={onSelect}
          row_limit={9999}
          columns={[
            {
              sort: false,
              cell: (item: any) => (
                <div>
                  <div className="row ">
                    <div className="col">{item.qc_code} </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      {Typo.caption(
                        `${item.amount || ''} ${item.unit?.name || ''}`
                      )}
                    </div>
                    <div className="col tr">
                      {Typo.caption(`${Utils.date.formatDate(item.date)}`)}
                    </div>
                  </div>
                </div>
              ),
            },
          ]}
        />
      </MaxBox>
    </SimpleCard>
  );
};

const QcPicker = ({
  product_id,
  onSelect,
}: {
  product_id: number;
  onSelect: (t: any) => void;
}) => {
  const { data } = useProductQc(product_id);
  const { data: formulas } = useFormulaList(product_id);

  const [createBatch] = useMutation(`mutation createBatch($input: NewBatch){
      createNewBatch(input: $input)
    }`);
  if (!data || !formulas) {
    return <Loading />;
  }
  return (
    <SimpleGrid
      spacing={3}
      items={[
        {
          content: (
            <QcList
              onSelect={onSelect}
              header="QC Only"
              status={K.status.QCONLY}
              data={data}
              product_id={product_id}
              createBatch={createBatch}
            />
          ),
          size: 3,
        },
        {
          content: (
            <QcList
              onSelect={onSelect}
              header="Untested"
              status={K.status.UNTESTED}
              data={data}
              formulas={formulas.formula}
              product_id={product_id}
              createBatch={createBatch}
            />
          ),
          size: 3,
        },
        {
          content: (
            <QcList
              onSelect={onSelect}
              header="Pending Approval"
              status={K.status.PENDING}
              data={data}
            />
          ),

          size: 3,
        },
        {
          content: (
            <QcList
              onSelect={onSelect}
              header="Approved"
              status={K.status.APPROVED}
              data={data}
            />
          ),
          size: 3,
        },
      ]}
    />
  );
};

export default QcPicker;
